/**
 * 分类资源左侧
 * 2017-11-22
 * Bai.Zhiming
 */
'use strict';
angular.module('classifiedResourceLeftModule', ['locationNodeServiceModule']).directive('classifiedResourceLeft', [
    '$timeout',
    'trsHttpService',
    'messagePublishService',
    function($timeout, trsHttpService, messagePublishService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                selectedParent: '=',
            },
            templateUrl: './networkResource/classifiedResource/left/left_tpl.html',
            link: function(scope, $elem, $attrs, $rootScope) {
                let promise;
                initStatus();
                initData();

                /**
                 * [searchNode description] 关键词搜索
                 * @param  {[type]} $viewValue [description] 关键词
                 * @return {[type]}            [description]
                 */
                scope.searchNode = function($viewValue) {
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    scope.isVisable = false;
                    scope.typeaheadWidth = 0;
                    promise = $timeout(function() {
                        if ($viewValue !== '' && !angular.isObject($viewValue)) {
                            var params = {
                                typeid: 'zyzx',
                                serviceid: 'navigation',
                                modelid: 'getSearchMedias',
                                keyword: $viewValue,
                                section: scope.status.wayMap[scope.selectedParent.name],
                            };
                            return trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                                if ($viewValue) {
                                    scope.isVisable = true;
                                }
                                scope.data.searchNodeDataLen = data.length;
                                for (var i = 0; i < data.content.length; i++) {
                                    var name = data.content[i].name;
                                    data.content[i].allName = name;
                                    data.content[i].name = (function(name) {
                                        var nameArray = name.split('#');
                                        // 想要显示一个层级关系
                                        var showNameArray = nameArray[nameArray.length - 2] + '-' + nameArray[nameArray.length - 1];
                                        return showNameArray;
                                    })(name);
                                }
                                $timeout(function() {
                                    scope.typeaheadWidth = $('.searchword')
                                        .find('.resouce_center_typeahead')
                                        .prop('scrollWidth');
                                }, 300);
                                return data.content;
                            });
                        }
                    }, 800);
                    return promise;
                };

                scope.$watch('status.suggestion', function(newV, oldV) {
                    if (angular.isObject(newV)) {
                        $timeout(function() {
                            messagePublishService.publish('changclassifiedList', newV);
                            scope.$broadcast('searchNode', newV.points);
                        }, 1000);
                    }
                });
                scope.$watch('selectedParent', function(newV, oldV) {
                    if (angular.isObject(newV)) {
                        scope.status.suggestion = '';
                    }
                });

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        wayMap: {
                            数字报刊: 'szb',
                            网站: 'wz',
                            客户端: 'app',
                            微信: 'wx',
                            微博: 'wb',
                            视频: 'video',
                        },
                    };
                    scope.data = {};
                }

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {}
            },
        };
    },
]);
